import { Filters } from './useDashboardScreen';
import { MonthAndYear } from './components/CalendarSection/useCalendarSection';
import { useEffect } from 'react';
import { useShallowEqualSelector } from '../../utils/reduxUtils';
import { useDispatch } from 'react-redux';
import { DashboardActions } from './actions';
import { Currency } from '@card/types';

export type CalendarData = Record<string, { value: number } | undefined>;

export interface UseCalendarDataOptions {
  filters: Filters;
  monthAndYear: MonthAndYear;
  currency?: Currency;
}

export function useCalendarData(options: UseCalendarDataOptions) {
  const dispatch = useDispatch();
  const {
    soldAmounts,
    collectedAmounts,
    collectToday,
    collectTomorrow,
    monthlyChargebacks
  } = useShallowEqualSelector((s) => s.dashboard);

  useEffect(() => {
    dispatch(DashboardActions.fetchSoldAmountsStarted(options));
    dispatch(DashboardActions.fetchCollectedAmountsStarted(options));
  }, [dispatch, options]);

  useEffect(() => {
    dispatch(DashboardActions.fetchCollectTodayStarted());
  }, [dispatch]);
  useEffect(() => {
    dispatch(DashboardActions.fetchCollectTomorrowStarted());
  }, [dispatch]);
  useEffect(() => {
    dispatch(DashboardActions.fetchMonthlyChargebacksStarted());
  }, [dispatch]);

  return { soldAmounts, collectedAmounts, collectToday, collectTomorrow, monthlyChargebacks };
}
